import Immutable from "immutable";
import recordMerger from "services/record-merger";

export const modalBotRoutingConfigState = Immutable.Map({
  botTopics: Immutable.List([]),
  errorMessage: "",
  query: ""
});

export const BotTopic = Immutable.Record({
  clientId: null,
  clientToken: null,
  created: null,
  id: null,
  organizationId: null,
  topic: null,
  topicSimplified: null
});


export const modalBotRoutingConfig = (state = modalBotRoutingConfigState, action) => {
  let newState = state;

  switch (action.type) {
    case "GET_BOT_TOPICS_SUCCESS":
      newState = state.updateIn(["botTopics"], arr => arr.clear());
      action.response.data.bot_topics.forEach((topic) => {
        const newTopic = new BotTopic(recordMerger(topic, new BotTopic()));
        newState = newState.updateIn(["botTopics"], array => array.push(newTopic));
      });

      return newState;

    case "ADD_BOT_TOPICS_SUCCESS":
      newState = state.updateIn(["botTopics"], array => (
        array.push(new BotTopic(recordMerger(action.response.data.bot_topic, new BotTopic())))
      ));
      newState = newState.set("query", "");

      return newState;

    case "DELETE_BOT_TOPICS_SUCCESS":
      newState = state.updateIn(["botTopics"], array => (
        array.filter(topic => topic.id !== action.response.data.bot_topic._id)
      ));

      return newState;

    case "ADD_BOT_TOPICS_FAILURE":
      newState = state.set("errorMessage", action.response.data.message);

      return newState;

    case "BOT_TOPICS_UPDATE_QUERY":
      newState = newState.set("query", action.query);

      if (action.error) {
        newState = newState.set("errorMessage",
          "This topic has been previously added to your bot.");
      } else {
        newState = newState.set("errorMessage", "");
      }

      return newState;

    case "GET_BOT_TOPICS_FAILURE":
    case "DELETE_BOT_TOPICS_FAILURE":
    default:
      return state;
  }
};
